module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAV0lEQVQoFZXBsQ3AMAzAMOn/o10NHjoZCCmP5JGsCQdDZE04GCJrQgw/E2KIrAkx/EyIIbImHAyRNeFgiKwJMfxMiCGyJsTwMyGGyJpwMETWhIMh8kgefa87OA8FfNL6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_08.png
// module id = 230
// module chunks = 0